import { getGameList, getGamesByCategory, getGameById } from '@/api/games.api';
import router from '@/router';

const getDefaultState = () => ({
  games: [],
  channelsView: true,
  selectedName: '',
  selectedCategories: [],
  selectedGrades: [],
});

const state = getDefaultState();

const getters = {
  getGames: state => (params) => {
    if (!params) {
      return state.games;
    }
    const { grades } = params;
    const preKi = grades.indexOf('Pre-K');
    const ki = grades.indexOf('K');
    if (preKi !== -1) {
      grades[preKi] = -1;
    }
    if (ki !== -1) {
      grades[ki] = 0;
    }
    const { categories } = params;

    return state.games.filter((game) => {
      const isCategoryMatched = categories.length ? categories.includes(game.category) : true;
      const isGradeMatched = grades.length ? grades.includes(game.grade) : true;

      return game.name.toLowerCase().includes(params.name.toLowerCase())
        && isCategoryMatched
        && isGradeMatched;
    });
  },
  getGameNames: state => state.games.map(game => game.name),
  getGameById: state => (id) => {
    const gameId = String(id || router.currentRoute.params.id);
    return state.games.find(game => game.id.toString() === gameId);
  },
  getChannelsView: state => state.channelsView,
  getSelectedName: state => state.selectedName,
  getSelectedCategories: state => state.selectedCategories,
  getSelectedGrades: state => state.selectedGrades,
};

const actions = {
  async fetchGames({ commit }, { page, limit }) {
    try {
      const response = await getGameList(page, limit);
      commit('ADD_GAMES', response.data.games);
      return response;
    } catch (err) {
      throw err;
    }
  },
  async fetchGamesByCategory({ commit }, { skip, limit, category }) {
    try {
      const response = await getGamesByCategory({ skip, limit, category });
      commit('ADD_GAMES', response.data.games);
      return response;
    } catch (err) {
      throw err;
    }
  },
  async fetchGameById({ commit }, id) {
    try {
      const response = await getGameById(id);
      const { game } = response.data;
      commit('ADD_GAMES', [game]);
      return game;
    } catch (err) {
      throw err;
    }
  },
  addGames({ commit }, games) {
    commit('ADD_GAMES', games);
  },
  setChannelsView({ commit }, value) {
    commit('SET_CHANNELS_VIEW', value);
  },
  setSelectedName({ commit }, value) {
    commit('SET_SELECTED_NAME', value);
  },
  setSelectedCategories({ commit }, value) {
    commit('SET_SELECTED_CATEGORIES', value);
  },
  setSelectedGrades({ commit }, value) {
    commit('SET_SELECTED_GRADES', value);
  },
  cleanStorage({ commit }) {
    commit('CLEAN_STORAGE');
  },
};

const mutations = {
  CLEAN_STORAGE(state) {
    Object.assign(state, getDefaultState());
  },
  ADD_GAMES(state, games) {
    const addOrUpdate = (game) => {
      const gameIdx = state.games.findIndex(g => g.id === game.id);
      if (gameIdx === -1) {
        state.games.push(game);
      } else {
        state.games.splice(gameIdx, 1, game);
      }
    };
    games.forEach(addOrUpdate);
  },
  SET_CHANNELS_VIEW(state, value) {
    state.channelsView = value;
  },
  SET_SELECTED_NAME(state, value) {
    state.selectedName = value;
  },
  SET_SELECTED_CATEGORIES(state, value) {
    state.selectedCategories = value;
  },
  SET_SELECTED_GRADES(state, value) {
    state.selectedGrades = [...value];
    const iPreK = state.selectedGrades.indexOf('Pre-K');
    const iK = state.selectedGrades.indexOf('K');
    if (iPreK !== -1) {
      state.selectedGrades[iPreK] = -1;
    }
    if (iK !== -1) {
      state.selectedGrades[iK] = 0;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
